// removed by extract-text-webpack-plugin
module.exports = {"root":"FontStylePicker__root___3R7WG","item":"FontStylePicker__item___3BoSu","item--active":"FontStylePicker__item--active___QlxFJ","bold":"FontStylePicker__bold___2gI27","italic":"FontStylePicker__italic___1ku5H","underline":"FontStylePicker__underline___3v1pB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/FontStylePicker/FontStylePicker.scss
// module id = 999
// module chunks = 0